var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message",class:{ 'error-message' : _vm.$store.getters.getMessage.error === true }},[_vm._v(" "+_vm._s(_vm.$store.getters.getMessage.content)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }